import Layout from "../components/Layout";

const Projects = () => {
  return (
    <Layout>
      <div className="layout">
        <div className="max-w-4xl mx-auto mb-24">
          <h1 className="font-serif text-3xl font-medium tracking-wider mb-8">Projects</h1>
          <p className="text-[#000000]/70">Coming soon...</p>
        </div>
      </div>
    </Layout>
  );
};

export default Projects;
